import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import find from 'lodash/fp/find';
import ItemBreakdown from './ItemBreakdown';
import AmountModal from '../containers/AmountModal';
import Money from '../../money';
import Modal from '../../Modal';

const SplitPayment = ({
  title,
  close,
  item,
  refundAmount,
  togglePayment,
  payments,
  selectedPayments,
  disabled,
  toggleTip,
  selectedTips,
  selectedPayment,
  onSelectedSubmit,
  closeSelectedPayment,
}) => (
  <Modal
    title={<div>{title} <Money display-if={refundAmount}>{refundAmount}</Money></div>}
    close={close}
    showCloseButton
  >
    <div className="u-pv+ u-ph++">

      <div className="u-max-width-300 u-margin-auto">
        <ItemBreakdown item={item} />
      </div>

      <fieldset
        className="layout layout--auto layout--center u-mt+"
        disabled={disabled}
      >
        {payments.map((payment) => {
          if (!payment.canRefund) return null;
          const selectedItem = find({ id: payment.id }, selectedPayments);

          return (
            <div className="layout__item" key={payment.id}>
              <div className="c-label u-text-center">
                {payment.label}
              </div>

              <div className="c-input-group u-width-auto o-flexbox--justify-center">
                <button
                  key={payment.id}
                  type="button"
                  className={classnames('c-btn c-btn--outline c-btn--small', {
                    'is-active': selectedItem,
                  })}
                  onClick={togglePayment(payment)}
                  display-if={payment.amountWithoutTip}
                >
                  <span className="u-type--semibold u-mr-">Cost</span>
                  <span className="epsilon">
                    <span display-if={selectedItem}>
                      <Money>{selectedItem.amount}</Money>/
                    </span>
                    <Money>{payment.amountWithoutTip}</Money>
                  </span>
                </button>
                <button
                  key={`${payment.id}-tip`}
                  type="button"
                  className={classnames('c-btn c-btn--outline c-btn--small', {
                    'is-active': find({ id: payment.id }, selectedTips),
                  })}
                  onClick={toggleTip(payment)}
                  display-if={payment.tip}
                >
                  <span className="u-type--semibold u-mr-">TIP</span>
                  <span className="epsilon">
                    <Money>{payment.tip}</Money>
                  </span>
                </button>
              </div>
            </div>
          );
        })}

        <AmountModal
          max={selectedPayment.amountWithoutTip}
          onSubmit={onSelectedSubmit}
          close={closeSelectedPayment}
          display-if={selectedPayment}
        />

      </fieldset>
    </div>
  </Modal>
);
SplitPayment.propTypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  item: PropTypes.shape({
    cost: PropTypes.number,
    tipAmount: PropTypes.number,
    tax: PropTypes.number,
    promoAmounts: PropTypes.number,
    discountAmounts: PropTypes.number,
    refundedAmount: PropTypes.number,
    totalCost: PropTypes.number,
    giftCardAmount: PropTypes.number,
  }).isRequired,
  refundAmount: PropTypes.number.isRequired,
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      amount: PropTypes.number,
    }),
  ).isRequired,
  selectedPayments: PropTypes.arrayOf(PropTypes.object).isRequired,
  togglePayment: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  toggleTip: PropTypes.func.isRequired,
  selectedTips: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedPayment: PropTypes.shape({
    id: PropTypes.string,
  }),
  onSelectedSubmit: PropTypes.func.isRequired,
  closeSelectedPayment: PropTypes.func.isRequired,
};
SplitPayment.defaultProps = {
  selectedPayment: null,
};

export default SplitPayment;
